import { render, staticRenderFns } from "./MediaReferenceField.vue?vue&type=template&id=51269915&scoped=true&"
import script from "./MediaReferenceField.vue?vue&type=script&lang=js&"
export * from "./MediaReferenceField.vue?vue&type=script&lang=js&"
import style0 from "./MediaReferenceField.vue?vue&type=style&index=0&id=51269915&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51269915",
  null
  
)

export default component.exports